import moment from 'moment';
import React from 'react';
import { DataGridPro, GridToolbarExport, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton } from '@mui/x-data-grid-pro';
import { useParams } from 'react-router-dom';
import * as CustomerApi from '../../../Services/CustomerApi'

export default function PaymentHistory({profile, cards}) {
    const { customerId } = useParams();
    const [historyList, setHistoryList] = React.useState([])

    const columns = [
        { 
            field: 'id', 
            headerName: 'id', 
            width: 100, 
            editable: false ,
            hide: true,
        },
        {
            field: 'actionUTC',
            headerName: 'Payment taken (UTC)',
            type: 'date',
            width: 180, 
            valueFormatter: (params) => {
                return params.value ? moment(params.value).utc().format('DD MMM YYYY hh:mm a') : "";
            },
            valueGetter: (params) => {
                return params.value ? moment(params.value) : "";
            },
            editable: false,
        },
        { 
            field: 'actionLocal', 
            headerName: 'Payment taken (Subscription Timezone)', 
            width: 200, 
            editable: false ,
        },        
        {
            field: '',
            headerName: 'Action for',
            width: 100, 
            editable: false,
        },
        {
            field: 'subscription',
            headerName: 'Description',
            width: 300, 
            editable: false,
        },
        {
            field: 'card',
            headerName: 'Payment Mode',
            width: 150, 
            editable: false,
        },
        {
            field: 'type',
            headerName: 'Detail',
            width: 200, 
            editable: false,
        },
        {
            field: 'currency',
            headerName: 'Currency',
            width: 100, 
            editable: false,
        },
        {
            field: 'value',
            headerName: 'Value',
            width: 100, 
            editable: false,
        },
        {
            field: 'actionBy',
            headerName: 'Processed by',
            width: 120, 
            editable: false,
        },
    ];

    const fetchPaymentData = React.useCallback(async () => {
        const data = await CustomerApi.getCustomerSubscriptionHistory(customerId);
        const mappedList = [];
        var id = 0;

         // For all the subscriptions user had
        data.forEach((subscription) => {    
            const payments = subscription?.payments;
            const timezone = subscription?.subscriptionType?.timezone ? subscription?.subscriptionType?.timezone : 'UTC';
            const card = cards?.find(c => c.id === subscription?.subscriptionCard?.cardId);
            console.log(card);
            
            // For all payments of specific subscription including renewals
            payments.forEach((payment) => {                
                mappedList.push({
                    "actionUTC": payment?.paymentCreatedOn,
                    "actionLocal": `${moment(payment?.paymentCreatedOn).utc().tz(timezone).format('DD MMM YYYY hh:mm a')} ${moment.tz(timezone).zoneAbbr()}`,
                    "subscription": subscription?.subscriptionType?.name,
                    "card": payment?.transactionMode,
                    "type": payment?.transactionId,                   
                    "currency": payment?.transactionCurrencyCode,
                    "value": payment?.transactionValue,
                    "actionBy": payment.paymentCreatedBy,
                    "actionUTCMoment": moment(payment?.paymentCreatedOn).utc(),
                    "id": id,
                });
                id = id + 1;
            });
        });

        setHistoryList(mappedList);

    }, [customerId, cards]);

    React.useEffect(() => {
        fetchPaymentData();
    }, [fetchPaymentData])    

    return (
        historyList?.length > 0 ?
            <DataGridPro
                style={{ flex: 1 }}
                rows={[...historyList].sort((a,b)=>b.actionUTCMoment > a.actionUTCMoment ? 1 : -1)}
                columns={columns}
                pagination={true}
                pageSize={50}
                sx={{
                    '.MuiDataGrid-columnHeaders': {
                      fontWeight: 'bold',
                      fontSize: 14,
                      color: "rgb(0,0,0)",
                      backgroundColor: "rgb(244,246,248)"
                    },
                    '.MuiTablePagination-selectLabel': {
                      marginBottom: '0px',
                    },
                    '.MuiTablePagination-displayedRows': {
                      marginBottom: '0px',
                    },
                    '.MuiDataGrid-main': {
                        height: 'calc(100vh - 160px)',
                    },
                  }}
                components={{ Toolbar: dataGridToolbar }}
                componentsProps={{
                    panel: {
                      sx: {
                        '& .MuiTypography-root': {
                            color: '#000',
                        },
                        '& .MuiSwitch-switchBase.Mui-checked': {
                            color: '#D1517A',
                        },
                        '& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
                            backgroundColor: '#D1517A',
                        },                           
                        '& .MuiFormLabel-root': {
                            color: '#D1517A',
                        },
                        '& .MuiButton-root': {
                            color: '#D1517A',
                        },
                        '& .MuiInputLabel-root': {
                            color: '#D1517A',
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: '#D1517A',
                        },
                        '& .MuiInput-root:after': {
                            borderBottom: '1px solid #000',
                        },
                      },
                    },
                  }}
            />
            :
            <span style={{fontSize: '16px', paddingLeft: '15px'}}>{profile?.firstName + ' ' + profile?.lastName} is not yet a paid WonderPass subscriber</span>  
        
    );

    function dataGridToolbar() {
        return (
          <GridToolbarContainer style={{paddingTop: '10px'}}>
            <GridToolbarColumnsButton style={{color: '#434F69'}} />
            <GridToolbarFilterButton style={{color: '#434F69'}}/>
            <GridToolbarExport style={{color: '#434F69'}}/>
          </GridToolbarContainer>
        );
    }
}
